<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="d-flex">
        <h6 class="w-50"><strong>Behaviour</strong></h6>
      </div>
      <div class="align-items-center border rounded p-2 mb-3" style="border-color: lightgreen !important">
        <div v-for="behaviour in behaviours" v-bind:key="behaviour.name" class="form-check mb-2">
          <input class="form-check-input" v-b-tooltip.hover.html="getTooltip(behaviour)" v-on:change="checkboxChanged" type="checkbox" v-model="behaviour.value" :id="behaviour.name" :value="behaviour.value">
          <label class="form-check-label" v-b-tooltip.hover.html.topleft="getTooltip(behaviour)" :for="behaviour.name">{{behaviour.name}}</label>
        </div>
      </div>
      <div class="d-flex mb-3">
        <h6 :class="behavioursSelected.class">Behaviours selected: <strong>{{behavioursSelected.count}}</strong></h6>
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please tick the required number of checkboxes
      </div>
      <div>
        <p class="text-left mt-3">
          <a href="/#/recognition/how-to-write-a-motivation" class="aquacolor font-weight-bold" target="_blank">Click here</a> for a guide on: <span class="font-weight-bold">How to write a motivation for your nomination?</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'errorClass',
    'displayField',
    'checkboxlabels'
  ],
  data () {
    return {
      behaviours: [
        {name: 'Hold each other more accountable', value: false, tooltip: '1. Keeping our word – deadlines must be met at all times <br> 2. Once an agreement has been reached we expect people to deliver on what’s agreed <br> 3. We expect nothing but the best product from each function <br> 4. No finger pointing <br> 5. Take pride in delivering the best results for the business <br> 6. There are consequences for non-delivery'},
        {name: 'Trust and benefit of the doubt', value: false, tooltip: '1. Trust others to deliver and hold them accountable <br> 2. Support others, especially when they need it, not only if they ask <br> 3. Build trust by delivering excellence – consistency of outcome'},
        {name: 'Be vulnerable', value: false, tooltip: '1. Care for yourself, your teams so we can care for our customers <br> 2. Ask for support before crisis\'s emerge <br> 3. Getting the outcome is more important than being right. Smart jerks don’t win'},
        {name: 'Promote excellence', value: false, tooltip: '1. We put results, caring and working together above titles, positions and potential <br> 2. Your efforts and contribution is the ticket to growth and success <br> 3. Who you know counts little for our customers and stakeholders experience'},
        {name: 'Every action should promote the company', value: false, tooltip: '1. You are our brand, in what you say, do and champion. Make yourself and us proud <br> 2. Call out bad behaviours quickly and coach the right action <br> 3. Manage our resources well because it pays our salaries and grows our business, avoid duplication or fruitless costs'},
        {name: 'Operate like owners of the business', value: false, tooltip: '1. Bias for action <br> 2. Passionate dislike for bureaucracy <br> 3. Continuous drive to win customers loyalty, create better experience <br> 4. Manage costs actively, focus on outcomes <br> 5. Empower teams to get things done quickly <br> 6. Make a plan and works the plan for the result'},
        {name: 'Collaboration across the organisation', value: false, tooltip: '1. Get the right work, done right. Duplication is wasteful, it blunts our edge <br> 2. Build trust by being transparent <br> 3. Involve and work with others across our business to deliver results <br> 4. Execution is stronger and improvements are better when everyone is included <br> 5. Lead based on caring and skill, not on position'},
        {name: 'Faster response times', value: false, tooltip: '1. Get the right stuff done, now <br> 2. Stop the wrong stuff that does not make us win <br> 3. Meet timelines <br> 4. Operate with urgency and focus <br> 5. Speed is not permission to be a jerk'}
      ]
    }
  },
  computed: {
    behavioursSelected: function () {
      let notificationClass = 'warningColor'
      let selected = this.behaviours.filter(x => x.value).length
      if (selected > 0) {
        notificationClass = 'successColor'
      }
      return {class: notificationClass, count: selected}
    }
  },
  methods: {
    getTooltip: function (behaviour) {
      return behaviour.tooltip
    },
    setSelectedCountClass: function (count) {
      if (count < 5 && count > 0) {
        return 'warningColor'
      } else if (count <= 0) {
        return 'successColor'
      } else {
        return ''
      }
    },
    formatCheckBoxContent: function () {
      var formattedContent = '<ul>'
      for (var l = 0; l < this.behaviours.length; l++) {
        if (this.behaviours[l].value) {
          formattedContent += '<li>Behaviour: ' + this.behaviours[l].name + '</li>'
        }
      }
      return formattedContent + '</ul>'
    },
    checkboxChanged: function () {
      this.$emit('addedCheckBoxesContent', {
        label: this.label,
        content: this.formatCheckBoxContent(),
        validated: this.behavioursSelected.count >= 1,
        displayField: this.displayField
      })
    }
  }
}
</script>

<style lang="less">
  .warningColor {
    color: red !important;
  }
  .successColor {
    color: green !important;
  }
  label {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/FieldCheckBoxesBehaviours.vue